import { action } from 'mobx';
import { API, APIResponse } from '../types';
import { FeaturedVideo } from '../../../components/project-happy/utilities/types';

export class WebContentAPIController extends API {
  @action
  fetchFeaturedVideos = async () => {
    const url = `/web-content/featured-videos`;
    const resp = await this.request.get({ url });
    const json = (await resp.json()) as APIResponse<FeaturedVideo[]>;

    return json;
  };
}
